<template>
  <div :class="pageClass">
    <template v-if="tabelData.tabelData.length">
      <el-table
        :data="tabelData.tabelData"
        style="width: 100%"
        :class="[`${pageClass}-super-table`]"
        header-row-class-name="tableHead"
        :header-cell-style="{ background: '#f5f5f5', border: 'none' }"
      >
        <el-table-column label="试卷名称" width="200px">
          <template slot-scope="{ row }">
            <el-tooltip
              class="item"
              effect="dark"
              :content="row.title"
              placement="top-start"
            >
              <div class="paper-name">{{ row.title }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="学科">
          <template slot-scope="{ row }">
            <span class="st-icon-pandora">{{
              filterSubject(row.subjectId)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="wrongCount" label="答错题数"> </el-table-column>
        <el-table-column label="得分">
          <template slot-scope="{ row }">
            <span class="st-icon-pandora"
              >{{ row.allScore ? row.allScore : 0 }} 分</span
            >
          </template>
        </el-table-column>
        <el-table-column label="实际用时">
          <template slot-scope="{ row }">
            <span class="st-icon-pandora">{{
              formatSeconds(
                (row.timeUsed ? row.timeUsed : row.endTime - row.startTime) /
                  1000
              )
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="考试时间">
          <template slot-scope="{ row }">
            <span class="st-icon-pandora">{{ row.paperDuration }} 分钟</span>
          </template>
        </el-table-column>
        <el-table-column label="测评时间" width="250">
          <template slot-scope="{ row }">
            <span class="st-icon-pandora">{{
              row.endTime
                ? new Date(row.endTime).format("yyyy.MM.dd hh:mm:ss")
                : "暂无数据"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              v-on:click.native="toEvaluation(row.paperId, row.id, row.appId)"
              >查看结果</el-button
            >
            <br />
            <el-button
              v-if="row.appId == 100"
              type="text"
              v-on:click.native="
                popReport(
                  row.paperId,
                  row.title,
                  row.synthesize,
                  row.id,
                  row.appId
                )
              "
              >查看报告</el-button
            >
            <el-button
              v-else
              type="text"
              v-on:click.native="
                popReport(
                  row.paperId,
                  row.title,
                  row.synthesize,
                  row.id,
                  row.appId
                )
              "
              >查看报告</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <topic-page
        @currentChange="currentIndex"
        :page-index="tabelData.params.pageIndex"
        :total-count="tabelData.totalCount"
      ></topic-page>
    </template>
    <template v-else>
      <div class="nocountent">
        <img src="../../../assets/images/home/nocountent.jpg" alt="" />
        <p>暂无已评数据</p>
      </div>
    </template>
    <!-- 测评报告 -->
    <!-- <el-dialog
        :close-on-press-escape="true"
        center
        top="1vh"
        custom-class="success-submit-dialog"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        :visible.sync="dialogSubmitVisible"
        :show-close="false"
      >
        <div v-loading="submitLoading">
          <div class="top">
            <div class="lv">累计得分率=<span class="value">{{ `${average.totalObtainScoreRate}%` }}</span> <span style="font-size: 16px;">已做答{{average.testNum}}次</span></div>
            <div class="tip">本套试卷当前累计得分率=［（本次测评作答题目的实际总得分+本次未做但以前做对或改对题目的总赋分+本次未做但以前做错且未改正题目的实际总得分）÷（本套测评试卷总赋分）］</div>
            <div class="lv">本次得分率=<span class="value">{{ `${submitPaperInfo.lastObtainScoreRate}%` }}</span></div>
            <div class="tip">本次得分率=本次测评作答题目的实际总得分÷本次测评作答题目的总赋分</div>
          </div>
          <div class="center"></div>
          <div class="bottom">
            <div class="header">
              本套试卷满分<span class="fs20" style="color: #585858">{{ submitPaperInfo.objectiveScore + submitPaperInfo.subjectiveScore }}</span>分，你已得到<span class="fs20" style="color: #52c41a">{{ submitPaperInfo.objectiveObtainScore + submitPaperInfo.subjectiveObtainScore }}</span>分，失<span class="fs20" style="color: #ff0000">{{ (submitPaperInfo.subjectiveScore - submitPaperInfo.subjectiveObtainScore - submitPaperInfo.subjectiveUnDoScore) +  (submitPaperInfo.objectiveScore - submitPaperInfo.objectiveObtainScore - submitPaperInfo.objectiveUnDoScore) }}</span>分
              
            </div>
            <div class="kgbox">
              <div class="title">客观题总共<span class="fs20">{{ submitPaperInfo.objectiveScore }}</span>分</div>
              <div class="kgbox-c" v-if="submitPaperInfo.objectiveObtainScore">
                <span class="left">得<span class="fs20" style="color: #52c41a">{{ submitPaperInfo.objectiveObtainScore }}</span>分</span>
                <div class="right">
                  序号： <span v-for="(number, index) in submitPaperInfo.objectiveCorrectOriginalNameList" :key="index">{{ number }}</span>
                </div>
              </div>
              <div class="kgbox-c bgColor" v-if="submitPaperInfo.objectiveScore - submitPaperInfo.objectiveObtainScore - submitPaperInfo.objectiveUnDoScore">
                <span class="left">失<span class="fs20" style="color: #ff0000">{{ submitPaperInfo.objectiveScore - submitPaperInfo.objectiveObtainScore - submitPaperInfo.objectiveUnDoScore }}</span>分</span>
                <div class="right">
                  序号： <span v-for="(number, index) in submitPaperInfo.objectiveEorrOriginalNameList" :key="index">{{ number }}</span>
                </div>
              </div>
              <div class="kgbox-c bgColor" v-if="submitPaperInfo.objectiveUnDoScore">
                <span class="left">未作答<span class="fs20" style="color: #ff0000">{{ submitPaperInfo.objectiveUnDoScore }}</span>分</span>
                <div class="right">
                  序号： <span v-for="(number, index) in submitPaperInfo.objectiveUnDoOriginalNameList" :key="index">{{ number }}</span>
                </div>
              </div>
            </div>
            <div class="zgbox">
              <div class="title">主观题总共<span class="fs20">{{ submitPaperInfo.subjectiveScore }}</span>分</div>
              <div class="kgbox-c" v-if="submitPaperInfo.subjectiveObtainScore">
                <span class="left">得<span class="fs20" style="color: #52c41a">{{ submitPaperInfo.subjectiveObtainScore }}</span>分</span>
                <div class="right">
                  序号： <span v-for="(number, index) in submitPaperInfo.subjectiveCorrectOriginalNameList" :key="index">{{ number }}</span>
                </div>
              </div>
              <div class="kgbox-c" v-if="submitPaperInfo.subjectiveScore - submitPaperInfo.subjectiveObtainScore - submitPaperInfo.subjectiveUnDoScore">
                <span class="left">失<span class="fs20" style="color: #ff0000">{{ submitPaperInfo.subjectiveScore - submitPaperInfo.subjectiveObtainScore - submitPaperInfo.subjectiveUnDoScore }}</span>分</span>
                <div class="right">
                  序号： <span v-for="(number,index) in submitPaperInfo.subjectiveErrorOriginalNameList" :key="index">{{ number }}</span>
                </div>
              </div>
              <div class="kgbox-c bgColor" v-if="submitPaperInfo.subjectiveUnDoScore">
                <span class="left">未作答<span class="fs20" style="color: #ff0000">{{ submitPaperInfo.subjectiveUnDoScore }}</span>分</span>
                <div class="right">
                  序号： <span v-for="(number, index) in submitPaperInfo.subjectiveUnDoOriginalNameList" :key="index">{{ number }}</span>
                </div>
              </div>
            </div>
            <div class="footerButton">
              <button @click="closeWindow">关闭</button>
            </div>
          </div>
        </div>
      </el-dialog> -->

    <!-- 测评报告 -->
    <!-- 状态 0 正确； 1 半对； 2 未作 ； 3 错误 ;4 未自评 -->
    <el-dialog
      :close-on-press-escape="true"
      center
      custom-class="success-submit-new-dialog"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :visible.sync="dialogSubmitVisible"
      :show-close="true"
      @close="closeDialogSubmitVisible"
      top="20px"
    >
      <!-- :fullscreen="true" -->
      <div class="paper-name">{{ userName }}</div>
      <div class="paper-name">{{ pName }}</div>
      <div class="pop-name">测评报告</div>
      <div class="content" v-if="paperType != 1">
        <h3>本次测评结果</h3>
        <div class="scoring">
          本次测评得分率<span>{{ submitPaperInfo.lastObtainScoreRate }}%</span>
        </div>
        <div class="ping-msg">
          <div
            class="item-msg"
            v-if="+submitPaperInfo.lastObtainScoreRate < 65"
          >
            你的“{{
              pName
            }}专题板块”还有很大的提分空间，是需要你重点关注的部分。
          </div>
          <div
            class="item-msg"
            v-else-if="
              +submitPaperInfo.lastObtainScoreRate > 65 &&
              +submitPaperInfo.lastObtainScoreRate < 85
            "
          >
            你的“{{ pName }}专题板块”得分能力尚可，但还有提升空间。
          </div>
          <div
            class="item-msg"
            v-else-if="+submitPaperInfo.lastObtainScoreRate >= 85"
          >
            你的“{{ pName }}专题板块”得分能力优秀。
          </div>

          <div
            v-if="+submitPaperInfo.lastObtainScoreRate < 65"
            class="item-cont"
          >
            <span class="item">备考建议：</span>
            请在智能错题本中聆听名师精讲，认真重做错题，并利用提分宝典中的本专题相关辅导资源重点复习相关内容。之后继续完成本套试卷中未作答和做错的测试题目，以得到最终测评结果。
          </div>
          <div
            class="item-cont"
            v-else-if="
              +submitPaperInfo.lastObtainScoreRate > 65 &&
              +submitPaperInfo.lastObtainScoreRate < 85
            "
          >
            <span class="item">备考建议：</span>
            请在智能错题本中聆听名师精讲，认真重做错题，并选择提分宝典中适合自己的辅导资源针对性学习，之后继续完成本套试卷中未作答和做错的测试题目，以得到最终测评结果。
          </div>
          <div
            class="item-cont"
            v-else-if="
              +submitPaperInfo.lastObtainScoreRate >= 85 &&
              +submitPaperInfo.lastObtainScoreRate < 100
            "
          >
            <span class="item">备考建议：</span>
            请在智能错题本中聆听名师精讲，认真修改错题，之后继续完成本套试卷中未作答和做错的测试题目，以得到最终测评结果。
          </div>
          <div
            class="item-cont"
            v-else-if="+submitPaperInfo.lastObtainScoreRate == 100"
          >
            <span class="item">备考建议：</span>
            请在我的学习中聆听名师精讲，巩固提升。
          </div>
        </div>
      </div>
      <div class="content" v-if="paperType == 1">
        <h3>本次测评结果</h3>
        <p>
          本套测评卷共<span>{{ submitPaperInfo.questionCount }}</span
          >道题目（含小题）
        </p>
        <p>
          本次测评实做<span>{{
            pData.odoneTrue.length +
            pData.sdoneTrue.length +
            pData.odoneBandui.length +
            pData.sdoneBandui.length +
            pData.odoneFalse.length +
            pData.sdoneFalse.length
          }}</span
          >道题， 做对<span class="blue">{{
            pData.odoneTrue.length + pData.sdoneTrue.length
          }}</span
          >道， 半对<span class="red">{{
            pData.odoneBandui.length + pData.sdoneBandui.length
          }}</span
          >道, 做错<span class="red">{{
            pData.odoneFalse.length + pData.sdoneFalse.length
          }}</span
          >道
        </p>
        <p>
          本次测评得分<span>{{
            submitPaperInfo.objectiveCorrectScore +
            submitPaperInfo.objectiveHalfScore +
            submitPaperInfo.subjectiveCorrectScore +
            submitPaperInfo.subjectiveHalfScore
          }}</span
          >分
        </p>
      </div>
      <div class="content">
        <h3>本次测评概况</h3>
        <p
          v-if="
            pData.odoneTrue.length +
            pData.odoneBandui.length +
            pData.odoneFalse.length
          "
        >
          本次测评客观题共<span>{{
            pData.odoneTrue.length +
            pData.odoneBandui.length +
            pData.odoneFalse.length
          }}</span
          >题， 答对<span class="blue">{{ pData.odoneTrue.length }}</span
          >题， 得分<span class="blue">{{
            submitPaperInfo.objectiveCorrectScore
          }}</span
          >分， 半对<span class="red">{{ pData.odoneBandui.length }}</span
          >题， 得<span class="red">{{
            submitPaperInfo.objectiveHalfScore
          }}</span
          >分， 答错<span class="red">{{ pData.odoneFalse.length }}</span
          >题，失<span class="red">{{
            submitPaperInfo.objectiveErrorScore
          }}</span
          >分
        </p>
        <div
          class="content-box"
          v-if="
            pData.odoneTrue.length +
            pData.odoneBandui.length +
            pData.odoneFalse.length
          "
        >
          <span class="left">客观题：</span>
          <div class="show-status">
            <template
              v-for="(
                objective, index
              ) in submitPaperInfo.objectiveOriginalNameList"
            >
              <div class="item" :key="index" v-if="objective.status != 2">
                <span
                  :class="[
                    'origin-name',
                    { bgred: objective.status == 3 },
                    { bgblue: objective.status == 0 },
                    { bgblack: objective.status == 4 },
                    { bgbandui: objective.status == 1 },
                  ]"
                  >{{ objective.originalName }}</span
                >
                <div class="origin-img">
                  <img
                    v-if="objective.status == 0"
                    class="w22"
                    src="@/assets/images/paper/p-dui.jpg"
                  />
                  <img
                    v-if="objective.status == 3"
                    class="w17"
                    src="@/assets/images/paper/p-cuo.jpg"
                  />
                  <img
                    v-if="objective.status == 1"
                    class="w22"
                    src="@/assets/images/paper/p-bandui.jpg"
                  />
                </div>
              </div>
            </template>
          </div>
        </div>
        <p
          v-if="
            pData.sdoneTrue.length +
            pData.sdoneBandui.length +
            pData.sdoneFalse.length
          "
        >
          本次测评主观题题共<span>{{
            pData.sdoneTrue.length +
            pData.sdoneBandui.length +
            pData.sdoneFalse.length
          }}</span
          >题， 答对<span class="blue">{{ pData.sdoneTrue.length }}</span
          >题， 得分<span class="blue">{{
            submitPaperInfo.subjectiveCorrectScore
          }}</span
          >分， 半对<span class="red">{{ pData.sdoneBandui.length }}</span
          >题， 得<span class="red">{{
            submitPaperInfo.subjectiveHalfScore
          }}</span
          >分， 答错<span class="red">{{ pData.sdoneFalse.length }}</span
          >题，失<span class="red">{{
            submitPaperInfo.subjectiveErrorScore
          }}</span
          >分
        </p>
        <div
          class="content-box"
          v-if="
            pData.sdoneTrue.length +
            pData.sdoneBandui.length +
            pData.sdoneFalse.length
          "
        >
          <span class="left">主观题：</span>
          <div class="show-status">
            <template
              v-for="(
                subjective, index
              ) in submitPaperInfo.subjectiveOriginalNameList"
            >
              <div class="item" v-if="subjective.status != 2" :key="index">
                <span
                  :class="[
                    'origin-name',
                    { bgred: subjective.status == 3 },
                    { bgblue: subjective.status == 0 },
                    { bgblack: subjective.status == 4 },
                    { bgbandui: subjective.status == 1 },
                  ]"
                  >{{ subjective.originalName }}</span
                >
                <div class="origin-img">
                  <img
                    v-if="subjective.status == 0"
                    class="w22"
                    src="@/assets/images/paper/p-dui.jpg"
                  />
                  <img
                    v-if="subjective.status == 3"
                    class="w17"
                    src="@/assets/images/paper/p-cuo.jpg"
                  />
                  <img
                    v-if="subjective.status == 1"
                    class="w22"
                    src="@/assets/images/paper/p-bandui.jpg"
                  />
                </div>
              </div>
            </template>
          </div>
        </div>
        <!-- <div class="button">
            <button @click="toMyEvaluation">查看结果</button>
            <button class="right" @click="toWrongQuestion">看错题</button>
          </div> -->
      </div>
      <div class="content">
        <h3>累计测评情况</h3>
        <div class="scoring">
          目前累计得分率<span>{{ scoreRate.totalObtainScoreRate }}%</span>
        </div>
        <!-- 综合卷测评报告 -->
        <div class="ping-yu" v-if="paperType == 1">
          <template
            v-if="pData.odoneWeizuo.length + pData.sdoneWeizuo.length > 0"
          >
            你尚有{{
              pData.odoneWeizuo.length + pData.sdoneWeizuo.length
            }}题未完成，如果你想根据此卷测评结果预测你本学科的高考得分，请完成本卷全部测评题目。
          </template>
          <template v-else>
            你已完成本综合卷全部测评试题，通过本次综合测评，预测你本学科的高考成绩为{{
              scoreRate.expectGkScore
            }}分。
          </template>
        </div>
        <!-- 专题卷测评报告 -->
        <div class="ping-yu" v-else>
          <template
            v-if="pData.odoneWeizuo.length + pData.sdoneWeizuo.length > 0"
          >
            你尚有{{
              pData.odoneWeizuo.length + pData.sdoneWeizuo.length
            }}题未完成，你应该在二模之前完成本专题全部测评题目，以得到本专题最终测评结果，及早查缺补漏
          </template>
          <template v-else>
            <template v-if="scoreRate.totalObtainScoreRate < 85">
              你已完成本专题全部测评试题，请在智能错题本中重点聆听错题（包括已改正过的错题）对应的名师精讲，并重做错题，直到错题彻底搞懂
            </template>
            <template
              v-else-if="
                scoreRate.totalObtainScoreRate >= 85 &&
                scoreRate.totalObtainScoreRate < 100
              "
            >
              你已完成本专题全部测评试题，你此部分专题已经基本过关，建议不用在此专题再花更多时间
            </template>
            <template v-else>
              你已完成本专题全部测评试题，你此部分专题已经完全过关，建议不用在此专题再花更多时间
            </template>
          </template>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import topicPage from "../../../../src/components/page/index";
import { resource } from "../../../mixins/my_personal";
// import solutionQuestion from '@/components/paper/question/concrete_question/solution_question';
export default {
  name: "evalusted",
  mixins: [resource],
  data() {
    return {
      submitLoading: true,
      average: {},
      submitPaperInfo: {
        objectiveScore: 0,
        subjectiveScore: 0, // 主观题总分数
        objectiveUnDoScore: 0, // 主观题总分数
        subjectiveUnDoScore: 0, // 主观题未作分数
        objectiveCorrectScore: 0, // 客观题正确分数
        subjectiveCorrectScore: 0, // 主观题正确分数
        objectiveHalfScore: 0, // 客观题半对分数
        subjectiveHalfScore: 0, // 主观题半对分数
        objectiveErrorScore: 0, // 客观题错误分数
        subjectiveErrorScore: 0, // 主观题错题分数
        objectiveOriginalNameList: [], //
        subjectiveOriginalNameList: [],
        lastObtainScoreRate: 0,
        questionCount: 0,
      }, // 分数
      dialogSubmitVisible: false,
      pageClass: "evaluationTabel",
      userName: "",
      pName: "",
      paperType: 0,
      pData: {
        done: [], // 客观题做答的题
        odoneTrue: [], // 客观题作对的
        odoneFalse: [], // 客观题作错的
        odoneWeizuo: [], // 客观题作错的
        odoneBandui: [], // 客观题作错的
        sdoneTrue: [], // 客观题作对的
        sdoneFalse: [], // 客观题作错的
        sdoneWeizuo: [], // 客观题作错的
        sdoneBandui: [], // 客观题作错的
      },
      scoreRate: {
        totalObtainScoreRate: 0,
      },
    };
  },
  props: {
    tabelData: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  computed: {
    filterSubject() {
      return function (data) {
        return this.subject[data];
      };
    },
  },
  components: {
    topicPage,
  },
  methods: {
    closeDialogSubmitVisible() {
      this.dialogSubmitVisible = false;
      this.submitPaperInfo.objectiveScore = 0;
      this.submitPaperInfo.objectiveUnDoScore = 0;
      this.submitPaperInfo.subjectiveUnDoScore = 0;
      this.submitPaperInfo.subjectiveScore = 0;
      this.submitPaperInfo.subjectiveCorrectScore = 0;
      this.submitPaperInfo.objectiveHalfScore = 0;
      this.submitPaperInfo.subjectiveHalfScore = 0;
      this.submitPaperInfo.objectiveErrorScore = 0;
      this.submitPaperInfo.subjectiveErrorScore = 0;
      this.submitPaperInfo.objectiveOriginalNameList = [];
      this.submitPaperInfo.subjectiveOriginalNameList = [];
      this.submitPaperInfo.lastObtainScoreRate = 0;
      this.submitPaperInfo.questionCount = 0;
      // this.pData.done = []
      this.pData.odoneTrue = [];
      this.pData.odoneFalse = [];
      this.pData.odoneWeizuo = [];
      this.pData.odoneBandui = [];
      this.pData.sdoneTrue = [];
      this.pData.sdoneFalse = [];
      this.pData.sdoneWeizuo = [];
      this.pData.sdoneBandui = [];
    },
    closeWindow() {
      this.dialogSubmitVisible = false;
      // try {
      //   cefJS.sendmsg('reportformclose');
      // } catch (error) {
      //   console.log(error)
      // }
    },
    // 弹出测评报告
    popReport(pid, title, synthesize, tid, appid) {
      if (appid == 100) {
        this.$router.push({
          path: "/report_detail",
          query: {
            paper_type: synthesize,
            paper_id: pid,
          },
        });
      } else {
        this.$router.push({
          path: "/report_history",
          query: {
            paper_id: pid,
            app_id: appid,
          },
        });
      }
      // // this.pData.yizuo = []
      // this.pName = title
      // this.paperType = synthesize
      // this.submitLoading = true
      // let userinfo = localStorage.getItem("userinfo");
      // const user = JSON.parse(userinfo);
      // this.userName = user.fullName || user.nickname || user.name
      // // 最后一次请求的数组
      // this.$HTTP.executeGet(`${this.$APIS.GET_PAPER_TOTAL_REPORT}/${user.id}/${pid}`, this).then((res) => {
      //   const { code, data, msg } = res
      //   if (code === 0) {
      //     this.submitPaperInfo = data
      //     // 数据出来之后要做处理
      //     for (let i = 0; i < this.submitPaperInfo.objectiveOriginalNameList.length; i++) {
      //       const element =  this.submitPaperInfo.objectiveOriginalNameList[i];
      //       if (element.status == 0) {
      //         this.pData.odoneTrue.push(element)
      //       } else if (element.status == 1) {
      //         this.pData.odoneBandui.push(element)
      //       } else if (element.status == 2) {
      //         this.pData.odoneWeizuo.push(element)
      //       } else if (element.status == 3) {
      //         this.pData.odoneFalse.push(element)
      //       }
      //     }
      //     for (let i = 0; i < this.submitPaperInfo.subjectiveOriginalNameList.length; i++) {
      //       const element =  this.submitPaperInfo.subjectiveOriginalNameList[i];
      //       if (element.status == 0) {
      //         this.pData.sdoneTrue.push(element)
      //       } else if (element.status == 1) {
      //         this.pData.sdoneBandui.push(element)
      //       } else if (element.status == 2) {
      //         this.pData.sdoneWeizuo.push(element)
      //       } else if (element.status == 3) {
      //         this.pData.sdoneFalse.push(element)
      //       }
      //     }

      //     this.$HTTP.executeGet(`${this.$APIS.GET_PAPER_TOTAL_SCORE}/${tid}`, this).then((res) => {
      //       const { code, data, msg } = res
      //       if (code === 0) {
      //         this.scoreRate = data
      //         this.dialogSubmitVisible = true
      //       } else {
      //         console.log(msg)
      //       }
      //     })
      //     this.submitLoading = false
      //   } else {
      //     this.submitLoading = false
      //     this.$message.error(msg)
      //   }
      // })
    },
    formatSeconds(value) {
      var theTime = parseInt(value); // 秒
      if (theTime < 0) {
        return "0秒";
      }
      var theTime1 = 0; // 分
      var theTime2 = 0; // 小时
      // alert(theTime);
      if (theTime > 60) {
        theTime1 = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        // alert(theTime1+"-"+theTime);
        if (theTime1 > 60) {
          theTime2 = parseInt(theTime1 / 60);
          theTime1 = parseInt(theTime1 % 60);
        }
      }
      var result = "" + parseInt(theTime) + "秒";
      if (theTime1 > 0) {
        result = "" + parseInt(theTime1) + "分" + result;
      }
      if (theTime2 > 0) {
        result = "" + parseInt(theTime2) + "小时" + result;
      }
      return result;
    },
    currentIndex(value) {
      this.$emit("changeIndexs", value);
    },
    toEvaluation(value, id, appId) {
      this.$router.push({
        path: "/evaluated_detail",
        query: {
          paper_id: value,
          test_id: id,
          app_id: appId,
          origin: "evaluated",
        },
      });
    },
  },
  mounted() {
    try {
      CefSharp.BindObjectAsync("cefJS");
    } catch (error) {
      console.log(error);
    }
  },
};
</script>
<style lang="scss" scoped>
.success-submit-new-dialog {
  /deep/ .el-dialog__header {
    padding: 0;
    display: none;
  }
  /deep/ .el-dialog__body {
    font-size: 18px;
    padding: 0 !important;
    margin: 0 !important;
  }
  .paper-name {
    width: 100%;
    text-align: center;
    font-size: 22px;
    line-height: 53px;
  }
  .pop-name {
    width: 100%;
    text-align: center;
    font-size: 22px;
    font-weight: 800;
  }
  .content {
    width: 100%;
    max-width: 1040px;
    border: 1px solid #ace292;
    background-color: #f4ffef;
    margin: 0 auto;
    margin-top: 30px;
    border-radius: 8px;
    color: #585858;
    .scoring {
      width: 100%;
      font-size: 26px;
      text-align: center;
      span {
        font-size: 32px;
        font-weight: 800;
        color: #ff0000;
      }
    }
    .ping-yu {
      font-size: 18px;
      line-height: 40px;
      padding: 20px;
      text-indent: 2em;
    }
    .ping-msg {
      font-size: 18px;
      line-height: 40px;
      padding: 20px;
      .item-msg {
        text-align: left;
        text-indent: 2em;
        font-weight: 600;
      }
      .item-cont {
        text-indent: 2em;
        .item {
          font-weight: 600;
        }
      }
    }
    h3 {
      font-size: 20px;
      font-weight: 800;
      line-height: 74px;
      padding-left: 30px;
    }
    p {
      font-size: 20px;
      text-align: center;
      line-height: 40px;
      span {
        font-size: 25px;
        font-weight: 800;
        vertical-align: bottom;
      }
    }

    .blue {
      color: #83c000;
    }

    .red {
      color: #ff0000;
    }

    .content-box {
      height: auto;
      width: 910px;
      margin: 0 auto;
      margin-top: 20px;
      .left {
        display: inline-block;
        vertical-align: top;
        font-size: 18px;
        line-height: 30px;
        margin-left: 30px;
      }
      .show-status {
        display: inline-block;
        vertical-align: top;
        overflow: auto;
        width: 780px;
        .item {
          height: 60px;
          min-width: 30px;
          float: left;
          margin-left: 10px;
          margin-bottom: 20px;
          .origin-name {
            height: 30px;
            display: block;
            width: auto;
            min-width: 30px;
            text-align: center;
            line-height: 30px;
            background: #aaaaaa;
            color: #fff;
            font-size: 15px;
            border-radius: 4px;
          }
          .origin-img {
            width: 100%;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            .w22 {
              width: 22px;
            }
            .w17 {
              width: 17px;
            }
          }

          .bgred {
            background: #ff0000;
          }

          .bgblue {
            background: #83c000;
          }

          .bgblack {
            background: #000000;
          }
          .bgbandui {
            background: #ff9000;
          }
        }
      }
    }
    .button {
      text-align: center;
      button {
        width: 170px;
        height: 50px;
        border-radius: 4px;
        border: none;
        outline: none;
        background-color: #3db0f0;
        color: #fff;
        font-size: 20px;
        margin-bottom: 30px;
        cursor: pointer;
      }
      .right {
        margin-left: 40px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.success-submit-dialog {
  /deep/ .el-dialog__header {
    padding: 0;
  }
  /deep/ .el-dialog__body {
    font-size: 18px;
    padding: 0 !important;
    margin: 0 !important;
  }
  height: 880px;
  width: 707px;
  padding: 15px;
  height: 100%;
  .evaluation-img {
    width: 100%;
    height: auto;
    background: #fff;
    padding-bottom: 200px;
    img {
      margin: 0 auto;
      padding-top: 100px;
      width: 360px;
      height: auto;
      display: block;
      margin-bottom: 200px;
    }
  }
  button {
    width: 170px;
    height: 50px;
    border-radius: 4px;
    background: #3db0f0;
    color: #fff;
    border: none;
    outline: none;
    cursor: pointer;
    margin: 30px auto;
    display: block;
    font-size: 20px;
  }
  .top {
    min-height: 120px;
    width: 100%;
    background: #fff;
    border-radius: 0 0 9px 9px;
    img {
      width: 68px;
      height: auto;
      display: block;
      margin: 0 auto;
    }
    h3 {
      font-size: 26px;
      color: #52c41a;
      height: 66px;
      line-height: 66px;
      text-align: center;
    }
    .lv {
      height: 54px;
      line-height: 54px;
      font-size: 19px;
      font-weight: 900;
      text-align: center;
      .value {
        font-size: 23px;
        color: #52c41a;
      }
    }
    .tip {
      font-size: 16px;
      color: #afafaf;
      text-align: center;
    }
  }
  .center {
    width: 100%;
    height: 10px;
    background: #efefef;
  }
  .bottom {
    background: #fff;
    border-radius: 9px 0;
    .header {
      line-height: 100px;
      color: #585858;
      text-align: center;
      .fs20 {
        font-size: 20px;
        font-weight: 800;
      }
    }
    .kgbox {
      width: 100%;
      background: #f0ffe9;
      border-radius: 20px;
      padding: 18px 0 0 0;
      .title {
        font-weight: 600;
        text-align: center;
        height: 38px;
        line-height: 38px;

        .fs20 {
          font-size: 20px;
          font-weight: 800;
        }
      }
      &-c {
        padding: 18px 73px;
        .left {
          display: inline-block;
          vertical-align: top;
          width: 140px;
          .fs20 {
            font-size: 20px;
            font-weight: 800;
          }
        }
        .right {
          display: inline-block;
          margin-left: 72px;
          width: 520px;
          span {
            height: 20px;
            min-width: 20px;
            display: inline-block;
            color: #009cff;
            border: 1px solid #009cff;
            border-radius: 20px;
            text-align: center;
            line-height: 20px;
            margin-left: 12px;
            font-size: 16px;
            padding: 3px 3px;
            margin-bottom: 6px;
          }
        }
      }
      .bgColor {
        border-radius: 9px;
        background: #ffeaea;
      }
    }
    .zgbox {
      width: 100%;
      background: #f4f4f4;
      border-radius: 9px;
      padding: 18px 0;
      margin-top: 10px;
      .title {
        font-weight: 600;
        text-align: center;
        height: 38px;
        line-height: 38px;
        .fs20 {
          font-size: 20px;
          font-weight: 800;
        }
      }
      &-c {
        padding: 18px 73px;
        .left {
          display: inline-block;
          vertical-align: top;
          width: 140px;
          .fs20 {
            font-size: 20px;
            font-weight: 800;
          }
        }
        .right {
          display: inline-block;
          margin-left: 72px;
          width: 520px;
          span {
            height: 20px;
            min-width: 20px;
            display: inline-block;
            color: #009cff;
            border: 1px solid #009cff;
            border-radius: 10px;
            text-align: center;
            line-height: 20px;
            margin-left: 12px;
            font-size: 16px;
            padding: 0 3px;
          }
        }
      }
    }
    .footerButton {
      display: flex;
      justify-content: center;
      button {
        width: 120px;
        height: 36px;
        cursor: pointer;
        background: #3db0f0;
        border: none;
        outline: none;
      }
    }
  }
}
</style>
<style lang="stylus" scoped>
/deep/ .el-button+.el-button {
  margin-left: 0;
}

.nocountent {
  width: 400px;
  margin: 0 auto;
  margin-top: 50px;
  position: relative;

  img {
    width: 100%;
  }

  p {
    color: #a9a9a9;
    font-size: 18px;
    width: 100%;
    position: absolute;
    bottom: 5px;
    text-align: right;
    padding-right: 40px;
  }
}

.evaluationTabel {
  padding: 0 60px;
  padding-bottom: 30px;

  .no-content {
    width: 100%;
    text-align: center;
    color: #7a8f9a;
    background-color: #ffffff;
    line-height: 160px;
  }

  overflow-y: auto;
  overflow-x: hidden;

  /deep/ &-super-table {
    right: -2px;

    .paper-name {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 16px;
    }

    .el-button--text {
      font-size: 16px;
    }
  }

  /deep/ .el-table th {
    text-align: center;
  }

  /deep/ .el-table td {
    text-align: center;
    padding: 10px 0 !important;
  }

  & >>> .el-table {
    th >.cell {
      font-size: 16px;
      font-weight: 800;
    }

    .cell {
      font-size: 16px;
      color: #3c3c3c;
    }
  }

  & >>> .el-table::before {
    /* 去除下边框 */
    height: 0;
  }
}
</style>